const UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

/** Human-readable byte count, e.g. 1536 -> "1.5 KB". */
export function formatBytes(bytes: number): string {
  let value = Math.max(0, bytes);
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const digits = unit === 0 ? 0 : 1;
  return `${value.toFixed(digits)} ${UNITS[unit]}`;
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString();
}

/** The route pattern the 500 handler stored in an error row's metaJson, or null when absent. */
export function errorRoute(metaJson: string | null): string | null {
  if (metaJson === null) return null;
  try {
    const meta: unknown = JSON.parse(metaJson);
    if (typeof meta === "object" && meta !== null && "route" in meta) {
      return typeof meta.route === "string" ? meta.route : null;
    }
  } catch {
    // Stored meta is best-effort context. A malformed value shows no route, not an error.
  }
  return null;
}
